<script setup>
const props = defineProps({
    value: String
})
</script>

<template>
    <span v-if="value" class="table-cell-hidden-icon-parent">
        {{ value }}
        <a :href="'mailto:' + value" class="bi-envelope table-cell-hidden-icon"></a>
    </span>
</template>